import { SET_USER_DETAILS } from "../action";
import { userDetails } from "./initial-store";

const initialState = userDetails;

function userDetailsReducer(state = initialState, action) {
  if (action.type === SET_USER_DETAILS) {
    return Object.assign(userDetails, action.payload);
  }
  return state;
}

export default userDetailsReducer;
